export default __webpack_public_path__ + "static/media/content4_2.b6acbe78.png";